import { getTeamApp, isTeamAppInitialized } from "./host/teamAppZoid";

const POLL_INTERVAL_MS = 50;
const DEFAULT_TIMEOUT_MS = 1500;

// Polls until the zoid bridge is ready (xprops populated), then reads
// the host-issued session token. Returns null on timeout / abort.
export async function getZoidToken(
  signal?: AbortSignal,
  timeoutMs: number = DEFAULT_TIMEOUT_MS,
): Promise<string | null> {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    if (signal?.aborted) return null;
    if (isTeamAppInitialized()) {
      return getTeamApp().token ?? null;
    }
    await sleep(POLL_INTERVAL_MS, signal);
  }
  return null;
}

function sleep(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve) => {
    const timer = setTimeout(resolve, ms);
    signal?.addEventListener(
      "abort",
      () => {
        clearTimeout(timer);
        resolve();
      },
      { once: true },
    );
  });
}
